import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronLeft} from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";

function ForgotPasswordConfirmation(){
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const email = queryParams.get("email");

    return(
        <div className="px-xxl-5">
            <div className="text-center mb-6">
                <div className="mb-3">
                    <h4 className="text-body-highlight mb-3">Please check your email</h4>
                    <p className="text-body-tertiary fs-8-1 mb-1">We’ve sent you an email to <strong>{email}</strong>  with instructions to reset your password.</p>
                    <p className="text-body-tertiary fs-8-1">  Please check your inbox or spam folder if you don’t see the email within a few minutes.</p>
                </div>
                <p>
                    <Link className="w-100 mb-3 fs-8-1 fw-bold " to="/auth/signin">
                        <FontAwesomeIcon className="me-2" icon={faChevronLeft} />Go to Signin page
                    </Link>
                </p>
                <p className="fs-9">
                    Didn’t receive the email? <Link to="#" className="fs-9 fw-bold ms-2" > Resend </Link>
                </p>
                <Link to="#" className="fs-9 fw-bold text-decoration-underline" > Support center </Link>
            </div>
        </div>
    )
}
export default ForgotPasswordConfirmation;